module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), (_vm.hasPermission('usuario.write')) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": "/cadastros/formas-organizacao-procedimento/novo"
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Novo\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.getDataTable()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtros.pesquisa),
      expression: "filtros.pesquisa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa: Entre com o nome ou código da forma de organização."
    },
    domProps: {
      "value": (_vm.filtros.pesquisa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filtros, "pesquisa", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover table-bordered table-striped"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.dataTable.data), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "hand",
      attrs: {
        "tag": "tr",
        "to": '/cadastros/formas-organizacao-procedimento/editar/' + item.id
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.codigo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.subgrupo.nome))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.dataTable.from) + " até " + _vm._s(this.dataTable.to) + " de " + _vm._s(this.dataTable.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.dataTable
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Formas de organização")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block"
  }, [_c('span', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar\n                  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Código")]), _vm._v(" "), _c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Subgrupo")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6a54a838"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastros/procedimentos/formas_organizacao/index.vue
// module id = 864
// module chunks = 0